import axiosService from '../axios.service';

const accountAgeDataService = {

    get(sessionId) {
        return new Promise((resolve) => {
            axiosService.api.get(`/accountAge/${sessionId}`)
                .then(response => {
                    resolve(response.data);
                })
        })
    },
    add(accountAge) {
        return new Promise((resolve) => {

            axiosService.api.post(`/accountAge`, accountAge)
                .then(response => {
                    resolve(response);
                })
        })
    },
    delete(session) {
        return new Promise((resolve) => {
            axiosService.api.delete(`/accountAge/` + session.id)
                .then(() => {
                    resolve(session);
                })
        })
    },
}

export default accountAgeDataService